import React from "react";
import { Text, View } from "native-base";
import { ArrowRight } from "lucide-react-native";
import { Platform } from "react-native";
import { webFont } from "../../Universal/API/API";
import PressableWrapp from "../../Universal/Buttons/PressableReact/PressableWrapp";

const webCursorPointer = Platform.OS === "web" ? ({ cursor: "pointer" } as any) : null;

type CartEmptyStateProps = {
  scaleAll: number;
  onOpenCatalog?: () => void;
  title?: string;
  description?: string;
  actionLabel?: string;
};

const CartEmptyState: React.FC<CartEmptyStateProps> = ({
  scaleAll,
  onOpenCatalog,
  title = "Корзина пуста",
  description = "Открой каталог или коллекции и добавь товары в текущий заказ.",
  actionLabel = "Перейти в каталог",
}) => {
  return (
    <View
      style={{
        borderRadius: 30 * scaleAll,
        backgroundColor: "#FFFFFF",
        borderWidth: 1,
        borderColor: "#ECE8E1",
        padding: 24 * scaleAll,
      }}
    >
      <Text
        selectable={false}
        style={{
          fontFamily: webFont("Inter"),
          fontSize: 24 * scaleAll,
          color: "#111111",
          fontWeight: "700",
          marginBottom: 8 * scaleAll,
        }}
      >
        {title}
      </Text>
      <Text
        selectable={false}
        style={{
          fontFamily: webFont("Inter"),
          fontSize: 15 * scaleAll,
          color: "#5F5B55",
          fontWeight: "500",
          lineHeight: 22 * scaleAll,
          marginBottom: 18 * scaleAll,
        }}
      >
        {description}
      </Text>

      {onOpenCatalog ? (
        <PressableWrapp
          onPress={onOpenCatalog}
          style={[
            {
              minHeight: 52 * scaleAll,
              borderRadius: 20 * scaleAll,
              backgroundColor: "#111111",
              paddingHorizontal: 20 * scaleAll,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              alignSelf: "flex-start",
            },
            webCursorPointer,
          ]}
        >
          <Text
            selectable={false}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 14 * scaleAll,
              color: "#FFFFFF",
              fontWeight: "700",
              marginRight: 8 * scaleAll,
            }}
          >
            {actionLabel}
          </Text>
          <ArrowRight size={16 * scaleAll} color="#FFFFFF" />
        </PressableWrapp>
      ) : null}
    </View>
  );
};

export default React.memo(CartEmptyState);
